import { Inject } from '@odinjs/odin';

import TableAPI from '@philips-emr/tws-components/lib/components/table/table/table-api';
import Controller, { OnClick } from '@philips-emr/tws-core/lib/client';
import SubmittableFragmentContext from '@philips-emr/tws-core/lib/component/context/submittable-fragment-context';
import { SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import isEmptyObject from '@philips-emr/tws-utils/lib/is-empty-object';

import { LocatorBankDataAliases as Aliases, FragmentNames } from '../../codegen';

@Controller({ fragment: FragmentNames.LOCATOR_BANK_DATA })
class LocatorBankDataController {

  @Inject('SubmittableFragmentContext')
  private submittableFragmentContext!: SubmittableFragmentContext;

  @Inject(Aliases.TABLE_BANK)
  private tableBank: TableAPI;

  @OnClick(Aliases.BUTTON_SELECT)
  onClick(): void {
    const [selected] = this.tableBank.getSelectedRows() || [];

    if (!isEmptyObject(selected)) {
      this.submittableFragmentContext.submit(new SubmitEvent({ record: selected }));
    }
  }
}

export default LocatorBankDataController;
